import shutterstock_111494318 from '../../assets/shutterstock_111494318.jpg';
import shutterstock_127438277 from '../../assets/shutterstock_127438277.jpg';
import curve_image1 from '../../assets/curve_image1.jpg'
import curve_image2 from '../../assets/curve_image2.jpg'
import { AppRouteURI } from "router/RoleBasedAccess";

export const ScenariosActionType = Object.freeze({
    SET_ALL_SCENARIOS: 'Scenarios:: Set all Scenarios',
    SET_SCENARIO_SELECTED: 'Scenarios:: Set Scenario Selected',
});

export const imageDict = {
    'shutterstock_322870733.jpg': curve_image1,
    'shutterstock_1187511808.jpg': curve_image2,
    'shutterstock_111494318.jpg': shutterstock_111494318,
    'shutterstock_127438277.jpg': shutterstock_127438277,
    'curve_image1.jpg': curve_image1,
    'curve_image2.jpg': curve_image2,
}

export const priorityOrdering = [
    {
      name: 'central_arizona_colorado_river_water_use_vs_access',
      route: AppRouteURI.VISUALIZATIONS + AppRouteURI.GUAGUE_VIZ,
    },
    {
      name: 'colarado_river_water_access',
      route: AppRouteURI.VISUALIZATIONS + AppRouteURI.MAP_VIZ,
    },
    {
      name: 'central_arizona_colorado_river_water_access_per_person_municipal_areas',
      route: AppRouteURI.VISUALIZATIONS + AppRouteURI.HONEYCOMB_VIZ,
    },
    {
      name: 'central_arizona_water_deliveries_and_uses',
      route: AppRouteURI.VISUALIZATIONS + AppRouteURI.DOUGHNUT_VIZ,
    },
    {
      name: 'colorado_river_access_by_water_priority_level',
      route: AppRouteURI.VISUALIZATIONS + AppRouteURI.AREA_VIZ,
    },
  ]